import { render, staticRenderFns } from "./ProjectLeave.vue?vue&type=template&id=29785670&"
import script from "./ProjectLeave.vue?vue&type=script&lang=js&"
export * from "./ProjectLeave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports